<template>
  <v-container
    v-if="item.title || item.subtitle"
    id="sobre"
    class="py-10 py-md-13 py-lg-16"
  >
    <TitleWidget :title="item.title" :subtitle="item.subtitle"></TitleWidget>

    <div
      v-if="item.text"
      class="
        grey--text
        text--darken-3 text-body-1 text-md-h6 text-center
        font-weight-regular
        mt-5 mt-md-6
        ck-content
        item-text
      "
      v-html="item.text"
    ></div>

    <div
      v-if="informations.whatsapp"
      class="d-flex flex-column align-center mt-10 mt-md-13 mt-lg-16"
    >
      <div
        class="
          primary--text
          text--darken-2
          text-h6
          text-sm-h5
          text-md-h4
          text-center
          text-uppercase
          font-weight-black
        "
      >
        agende sua manutenção
      </div>
      <div
        class="
          primary--text
          text--lighten-4
          text-h6
          text-sm-h5
          text-md-h4
          text-center
          text-uppercase
          font-weight-black
        "
      >
        preventiva hoje!
      </div>

      <v-btn
        class="px-4 px-sm-6 mt-5 mt-md-7 btn-action"
        color="primary lighten-4"
        :href="getWhatsappLinkFromPhone(informations.whatsapp)"
        target="_blank"
        :height="xsOnly ? 40 : 54"
        depressed
        outlined
        rounded
      >
        <v-icon class="mr-2" color="primary darken-4" :size="xsOnly ? 20 : 35">
          fa-whatsapp
        </v-icon>
        <span
          class="
            text-h6 text-sm-h5
            primary--text
            text--darken-4
            font-weight-bold
            mt-1
          "
        >
          {{ informations.whatsapp }}
        </span>
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";
import { getWhatsappLinkFromPhone } from "../../utils/getWhatsappLinkFromPhone";

const _config = {
  mod: "about",
};

export default {
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
    informations() {
      return this.$rest("informations").item;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    getWhatsappLinkFromPhone,
  },
  created() {
    this.$rest(_config.mod).get({
      save: (state, data) => (state.item = data),
    });
  },
  components: {
    TitleWidget,
  },
};
</script>

<style lang="scss" scoped>
.btn-action {
  border-width: 2px !important;
  line-height: 1 !important;
}
</style>
